var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.spinner,"spinner-variant":"primary"}},[_c('productosForm',{attrs:{"producto":_vm.productoData,"productoSubmit":"Crear Producto"},on:{"processProducto":_vm.agregarProductos}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }